import { render, staticRenderFns } from "./SupplierRawMaterialGlobalSuitability.vue?vue&type=template&id=92e0e456&scoped=true"
import script from "./SupplierRawMaterialGlobalSuitability.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialGlobalSuitability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e0e456",
  null
  
)

export default component.exports